<template>
  <div class="layout-fluid recharge">
    <div class="layout-card mb12">
      <div class="layout-card-header">
        <p>卡片充值</p>
        <!-- <div class="phone-recharge">
          <input
            type="text"
            placeholder="忘记带卡？输入手机号进行充值"
            v-model="rechargePhone"
            autoComplete="off"
          />
          <button
            type="button"
            v-preventReClick
            class="rechargePhoneBtn"
            @click="rechargePhoneHandle"
          >
            查询
          </button>
        </div> -->
      </div>
      <div class="layout-card-body recharge-body">
        <div class="recharge-form">
          <el-row :gutter="gutter">
            <el-col :span="10">
              <div class="item">
                <p class="name">
                  卡号
                  <img
                    src="../../assets/images/icon/icon_asterisk.png"
                    alt=""
                  />
                </p>
                <div class="cardnumber-box" style="width: 440px">
                  <input
                    type="password"
                    autocomplete="new-password"
                    v-model="cardNumber"
                    class="number-left cpuCardUtilCardNumber"
                    placeholder="请刷卡"
                    autofocus
                    v-focus="true"
                    @input="cardNumberBlur"
                  />
                  <input
                    type="text"
                    v-model="showCardNumber"
                    class="number-right"
                    placeholder="请输入卡号"
                    disabled
                  />
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="item">
                <p class="name">持卡人</p>
                <input
                  type="text"
                  v-model="cardHolder"
                  class="form-input"
                  placeholder="持卡人"
                  style="width: 1.93rem"
                  disabled
                />
              </div>
            </el-col>
            <el-col :span="8">
              <div class="item">
                <p class="name">手机号</p>
                <input
                  type="text"
                  style="width: 3.6rem"
                  v-model="phone"
                  class="form-input"
                  placeholder="手机号"
                  disabled
                />
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="gutter">
            <el-col :span="10">
              <div class="flex-row" style="width: 4.4rem">
                <div class="item">
                  <p class="name">卡片类型</p>
                  <input
                    type="text"
                    v-model="cardType"
                    class="form-input"
                    placeholder="卡片类型"
                    style="width: 1.8rem"
                    disabled
                  />
                </div>
                <div class="item">
                  <p class="name">开卡时间</p>
                  <input
                    type="text"
                    v-model="createDate"
                    class="form-input"
                    placeholder="开卡时间"
                    style="width: 2.44rem"
                    disabled
                  />
                </div>
              </div>
            </el-col>
            <el-col :span="6" v-if="cardTypeValue !== 3">
              <div class="item">
                <p class="name">可用余额（元）</p>
                <input
                  type="text"
                  v-model="onLineBalance"
                  class="form-input"
                  placeholder="可用余额（元）"
                  style="width: 1.93rem"
                  disabled
                />
              </div>
            </el-col>
            <el-col :span="8" v-if="cardTypeValue !== 3">
              <div class="item">
                <p class="name">充值方式</p>
                <div class="radio-list" style="margin-top: 0.27rem">
                  <el-radio v-model="rechargeMode" label="0">现金</el-radio>
                  <el-radio v-model="rechargeMode" label="1" v-show="false">农行</el-radio>
                  <el-radio v-model="rechargeMode" label="2"> 微信 </el-radio>
                  <el-radio v-model="rechargeMode" label="3"> 支付宝 </el-radio>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="layout-card mb12" v-if="cardTypeValue !== 3">
      <div class="layout-card-body recharge-info-body">
        <div class="recharge-info-form">
          <div class="price-item">
            <h2 class="title flex-row">充值金额</h2>
            <div class="box">
              <h1>￥</h1>
              <input
                type="text"
                class="price-input"
                v-model="amount"
                ref="amountRef"
              />
              <span>元</span>
            </div>
          </div>
          <div class="tip">
            <h2 class="title flex-row op">充值金额</h2>
            <div class="right">{{ utils.money(amount) }}</div>
          </div>
          <div class="flex-row item-foot">
            <button
              type="button"
              class="foot-btn cancel-btn mr30"
              @click="cancel"
            >
              取消
            </button>
            <button
              type="button"
              v-preventReClick
              class="foot-btn save-btn ml30"
              :disabled="isDisabled"
              @click="save"
            >
              保存
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- dialog -->
    <el-dialog
      :visible.sync="isSuccessDialog"
      :append-to-body="true"
      :show-close="false"
      :before-close="closeSuccessDislog"
      custom-class="success-dialog"
      width="620px"
    >
      <div slot="title">
        <div class="dialog-body">
          <div class="success-pop flex-column">
            <img src="../../assets/images/icon/icon_successful_2.png" />
            <h2 class="title">充值成功</h2>
            <h2 class="subtitle flex-row">
              当前余额 <b>{{ onLineBalance }} 元</b>
            </h2>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="isSuccessvipDialog"
      :append-to-body="true"
      :show-close="false"
      custom-class="success-dialog"
      width="620px"
    >
      <div slot="title">
        <div class="dialog-body">
          <div class="success-pop flex-column">
            <img src="../../assets/images/icon/icon_successful_2.png" />
            <h2 class="title">操作成功</h2>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 扫码dialog -->
    <el-dialog
      :visible.sync="isScanDialog"
      :append-to-body="true"
      :show-close="false"
      custom-class="scan-dialog"
      width="720px"
    >
      <div slot="title">
        <div class="dialog-header">
          <span>{{ rechargeMode === '1' ? '使用农行支付' : rechargeMode === '3' ? '使用支付宝支付' : '使用微信支付' }}</span>
          <i class="icon-close" @click="isScanDialog = false"
            ><img src="../../assets/images/icon/icon_close.png"
          /></i>
        </div>
        <div class="dialog-body scan-dialog-body">
          <h2>扫码付款</h2>
          <div class="box flex-between">
            <p>
              充值金额：<span>¥{{ amount }}</span>
            </p>
            <p>
              手续费：<span
                >{{ payInfo.payRate }}%（¥{{ payInfo.payFee }}）</span
              >
            </p>
          </div>
          <div class="total">
            合计金额：<span>¥{{ payInfo.payAmount }}</span>
          </div>
          <div class="scan-box" v-loading="scanLoading">
            <div id="qrcode" class="qrcode" ref="qrCodeUrl"></div>
          </div>
          <div class="scan-foot" v-if="rechargeMode === '1'">
            <img src="../../assets/images/nh.png" alt="" />
          </div>
          <div class="scan-foot" v-if="rechargeMode === '2'">
            <img style="max-width: 30px;" src="../../assets/images/wx-icon.png" alt="" />
          </div>
          <div class="scan-foot" v-if="rechargeMode === '3'">
            <img style="max-width: 40px" src="../../assets/images/alipay-icon.png" alt="" />
          </div>
        </div>
      </div>
    </el-dialog>
    <div style="display: none">
      <button v-print="printObj" id="printId" ref="printRef">打印</button>
      <div id="printMe" style="margin-left: -1px">
        <h1 style="font-size: 16px; text-align: center; margin-bottom: 5px">
          {{ companyName }}
        </h1>
        <p style="font-size: 14px; text-align: center; margin-bottom: 15px">
          充值
        </p>
        <p style="line-height: 1.8">
          操<font style="opacity: 0; margin-left: -6px">想</font>作<font
            style="opacity: 0; margin-left: -6px"
            >想</font
          >员：{{ printItem.opUser }}
        </p>
        <p style="line-height: 1.8">
          流<font style="opacity: 0; margin-left: -6px">想</font>水<font
            style="opacity: 0; margin-left: -6px"
            >想</font
          >号：NO.{{ printItem.numberOrder }}
        </p>
        <p style="line-height: 1.8">
          时<font style="opacity: 0">试试</font>间：{{
            utils.dateFormat(printItem.dataTime, "YYYY-MM-DD HH:MM:SS:ll")
          }}
        </p>
        <hr style="border-top: 1px dashed #333333; margin: 10px 0" />
        <p style="line-height: 1.8">
          姓<font style="opacity: 0">试试</font>名：{{ printItem.name }}
        </p>
        <p style="line-height: 1.8">
          手<font style="opacity: 0; margin-left: -6px">想</font>机<font
            style="opacity: 0; margin-left: -6px"
            >想</font
          >号：{{ printItem.phone }}
        </p>
        <p style="line-height: 1.8">
          充值卡号：
          <span style="font-size: 15px">NO.{{ printItem.showCardNumber }}</span>
        </p>
        <p style="line-height: 1.8">
          原卡余额：{{
            (printItem.balance - printItem.changeAmount).toFixed(2)
          }}
        </p>
        <p style="line-height: 1.8">支付方式：{{ printItem.payTypeDesc }}</p>
        <p style="line-height: 1.8">
          充值金额：<span style="font-size: 15px"
            >￥{{ printItem.changeAmount }}</span
          >
        </p>
        <p style="line-height: 1.8">
          大写金额：{{ utils.money(printItem.changeAmount) }}
        </p>
        <p style="line-height: 1.8">
          卡内余额：<span style="font-size: 15px"
            >￥{{ printItem.balance }}</span
          >
        </p>
        <p style="line-height: 1.8">备注：{{ printItem.remark }}</p>
        <hr style="border-top: 1px dashed #333333; margin: 10px 0" />
        <p style="line-height: 1.8">欢迎使用智能称重结算系统</p>
        <!-- <hr style="border-top: 1px dashed #333333; margin: 20px 0;" /> -->
        <p style="line-height: 1.8; margin: 20px 0 20px 0px">.</p>
      </div>
    </div>
  </div>
</template>

<script>
import * as cpuCardUtil from "../cardUtil/cpuCardUtil";
import QRCode from "qrcodejs2";
export default {
  cpuCardUtil: [cpuCardUtil],
  data() {
    return {
      rechargeMode: "0",
      // 卡号
      cardNumber: "",
      cardType: "主卡",
      // 卡类型
      cardTypeValue: 1,
      // 开卡单位
      cardCompany: "",
      // 持卡人
      cardHolder: "",
      onLineBalance: "",
      // 布局间隔
      gutter: 20,
      createDate: "",
      cardId: "",
      amount: "",
      phone: "",
      remark: "",
      showCardNumber: "",
      rechargePhone: "",
      isSuccessDialog: false,
      isSuccessvipDialog: false,
      surplus: 0,
      isPhoneRecharge: false,
      printItem: {},
      printObj: {
        id: "printMe",
        popTitle: "good print",
        extraCss: "",
        extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>',
      },
      isActivate: 1,
      // 二维码加载中
      scanLoading: false,
      // 是否显示扫码弹框
      isScanDialog: false,
      // 支付参数
      payInfo: {},
      // 公司名称
      companyName: "",
      // 是否禁用保存按钮
      isDisabled: false,
    };
  },
  components: {},
  //监听属性 类似于data概念
  computed: {},
  filters: {
    //局部过滤器

    toChies: function (values) {
      //形参
      let len = values.length; //统计出长度
      let arr = [];

      let chin_list = [
        "零",
        "壹",
        "贰",
        "叁",
        "肆",
        "伍",
        "陆",
        "柒",
        "捌",
        "玖",
      ]; //所有的数值对应的汉字

      let chin_lisp = [
        "仟",
        "佰",
        "拾",
        "亿",
        "仟",
        "佰",
        "拾",
        "万",
        "仟",
        "佰",
        "拾",
      ]; //进制

      for (let i = 0; i < len; i++) {
        arr.push(parseInt(values[i])); //输入的数据按下标存进去   存进去的只是数字
        arr[i] = chin_list[arr[i]]; //是根据我们输入的输入的数字，对应着我们的chin_list这个数组
      } //123['壹','佰','贰','拾','叁']

      for (let i = len - 1, j = 1; i > 0; i--) {
        //i =2	1		//倒序		为了添加进制，方便我们去观看
        arr.splice(i, 0, chin_lisp[chin_lisp.length - j++]); //j=2
      }

      arr = arr.join("");
      if (len >= 1) {
        arr += "元整";
      }
      return arr;
    },
  },
  //监控data中的数据变化
  watch: {
    cardNumber() {
      this.cardNumber = this.cardNumber.replace(/[\W]/g, "");
    },
    amount() {
      if (this.amount && this.amount !== 0) {
        this.amount = this.amount
          .replace(/[^\d.]/g, "")
          .replace(/\.{2,}/g, ".")
          .replace(".", "$#$")
          .replace(/\./g, "")
          .replace("$#$", ".")
          .replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3")
          .replace(/^\./g, "");
      }
    },
  },
  //方法集合
  methods: {
    cardNumberBlur() {
      this.getByCardNumber();
    },
    getByCardNumber() {
      var reg = /^[0-9a-zA-Z]*$/g;
      if (
        this.cardNumber !== "" &&
        reg.test(this.cardNumber) &&
        this.cardNumber.length == 8
      ) {
        let toLowerMdCaseNumber = "";
        if (this.oldCardNumber) {
          toLowerMdCaseNumber = this.oldCardNumber;
        } else {
          let toLowerCaseNumber = this.cardNumber.toLowerCase();
          let mdNumber = this.$md5(toLowerCaseNumber);
          toLowerMdCaseNumber = mdNumber.toLowerCase();
        }
        this.$api
          .getByCardNumber(toLowerMdCaseNumber)
          .then((result) => {
            let res = result.data;
            this.cardCompany = res.dealerName;
            this.cardHolder = res.cardHolder;
            this.phone = res.phone;
            this.cardTypeValue = res.cardType;
            this.cardType = res.cardTypeDesc;
            // if (res.cardType == 1) {
            //   this.cardType = "主卡";
            // } else if (res.cardType) {
            //   this.cardType = "副卡";
            // } else if (res.cardType == 3) {
            //   this.cardType = "管理员卡";
            // } else if (res.cardType == 4) {
            //   this.cardType = "VIP卡";
            // }
            this.onLineBalance = res.onLineBalance;
            this.createDate = this.utils.dateFormat(
              res.createDate,
              "YYYY-MM-DD HH:MM:SS"
            );
            this.cardId = res.cardId;
            this.showCardNumber = "NO." + res.showCardNumber;
            this.curTime = res.curTime;
            this.isActivate = res.isActivate ? 1 : 2;
            this.$nextTick(() => {
              this.$refs.amountRef.focus();
            });
          })
          .catch((err) => {
            this.cardNumber = "";
            this.showCardNumber = "";
          });
      }
    },
    rechargePhoneHandle() {
      let telStr =
        /^[1](([3][0-9])|([4][5-9])|([5][0-3,5-9])|([6][5,6])|([7][0-8])|([8][0-9])|([9][1,8,9]))[0-9]{8}$/;
      if (!telStr.test(this.rechargePhone)) {
        this.$Alert.info({
          content: "请输入正确的手机号",
          duration: 3000,
          status: "error",
        });
        return;
      }
      this.phoneRecharge();
      this.isPhoneRecharge = true;
    },
    phoneRecharge() {
      this.$api
        .GetCardByPhone(1, this.rechargePhone)
        .then((res) => {
          this.cardNumber = "00000000";
          this.cardCompany = res.dealerName;
          this.cardHolder = res.cardHolder;
          this.phone = res.phone;
          this.cardTypeValue = res.cardType;
          this.cardType = res.cardTypeDesc;
          // if (res.cardType == 1) {
          //   this.cardType = "主卡";
          // } else if (res.cardType) {
          //   this.cardType = "副卡";
          // } else if (res.cardType == 3) {
          //   this.cardType = "管理员卡";
          // } else if (res.cardType == 4) {
          //   this.cardType = "VIP卡";
          // }
          this.onLineBalance = res.onLineBalance;
          this.createDate = this.utils.dateFormat(
            res.createDate,
            "YYYY-MM-DD HH:MM:SS"
          );
          this.cardId = res.cardId;
          this.showCardNumber = "NO." + res.showCardNumber;
          this.curTime = res.curTime;
        })
        .catch((err) => {
          this.$Alert.info({
            content: err.response.data,
            duration: 3000,
            status: "error",
          });
        });
    },
    // 关闭充值成功弹框
    closeSuccessDislog() {
      // this.reset();
      this.isSuccessDialog = false;
    },
    // 重置
    reset() {
      this.cardNumber = "";
      this.showCardNumber = "";
      this.cardHolder = "";
      this.phone = "";
      this.createDate = "";
      this.amount = "";
      this.rechargeMode = "0";
      this.remark = "";
      this.onLineBalance = "";
    },
    // cancel
    cancel() {
      this.$router.go(-1);
    },
    // 保存
    async save() {
      if (!this.cardNumber) {
        this.$Alert.info({
          content: "请输入卡号",
          duration: 3000,
          status: "error",
        });
        return;
      }
      if (!this.amount || this.amount == 0) {
        this.$Alert.info({
          content: "请输入充值金额",
          duration: 3000,
          status: "error",
        });
        return;
      }
      // 删除
      const h = this.$createElement;
      this.$msgbox({
        title: "您确定要充值吗？",
        customClass: "popMessage",
        message: h("div", null, [
          h(
            "p",
            {
              style:
                "font-size: 60px; line-height:60px; text-align: center; color: #f3840d; margin-bottom: 40px; margin-top: 20px;",
            },
            this.amount + "元"
          ),
          h(
            "p",
            {
              style:
                "font-size: 60px; text-align: center; line-height:60px; margin-bottom: 30px;",
            },
            this.utils.money(this.amount)
          ),
        ]),
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(() => {
        let rechargeMode = this.rechargeMode;
        let amount = this.amount;
        if (amount.toString().indexOf(".") == -1) {
          amount = amount + ".00";
        }
        amount = Number(amount).toFixed(2);
        switch (rechargeMode) {
          case "1":
            // 农行
            this.scanQRRecharge(amount, 1);
            break;
          case "2":
            //微信
            this.scanQRRecharge(amount, 2);
            break;
          case "3": 
            //支付宝
            this.scanQRRecharge(amount, 3);
              break;
          default:
            // 现金
            this.cashRecharge(amount);
            this.isDisabled = true;
            break;
        }
      });
    },
    // 创建二维码
    createQrcode(url) {
      new QRCode(this.$refs.qrCodeUrl, {
        text: url, // 需要转换为二维码的内容
        width: 220,
        height: 220,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      });
    },
    // 线上充值 - 现金
    async cashRecharge(amount) {
      let sign = `CardId=${this.cardId}&Amount=${amount}&CurTime=${this.curTime}`;
      let mdSign = this.$md5(sign);
      let toLowerMdSign = mdSign.toLowerCase();
      let params = {
        cardId: this.cardId,
        amount,
        curTime: this.curTime,
        sign: toLowerMdSign,
      };
      let result = await this.$api.cashRecharge(params);
      let res = result.data;
      if (res.remark) {
        this.isSuccessDialog = true;
        this.amount = "";
        this.printItem = res;
        // setTimeout(() => {
        //   document.getElementById("printId").click();
        // }, 300);
        // setTimeout(() => {
        //   document.getElementById("printId").click();
        // }, 600);
        if (this.isPhoneRecharge) {
          this.phoneRecharge();
        } else {
          this.getByCardNumber();
        }
        this.isDisabled = false;
      }
    },
    // 扫码
    async scanQRRecharge(amount, payWay) {
      let params = {
        payWay,
        cardId: this.cardId,
        amount,
      };
      this.isScanDialog = true;
      const codeHtml = document.getElementById("qrcode");
      codeHtml.innerHTML = "";
      this.scanLoading = true;
      let result = await this.$api.scanQRRecharge(params);
      let res = result.data;
      if (res.payNo) {
        this.payInfo = res;
        setTimeout(() => {
          new QRCode(this.$refs.qrCodeUrl, {
            text: res.payUrl, // 需要转换为二维码的内容
            width: 200,
            height: 200,
            colorDark: "#000000",
            colorLight: "#ffffff",
            correctLevel: QRCode.CorrectLevel.H,
          });
          this.scanLoading = false;
        }, 1000);
        // 开始执行定时器
        let timer = setInterval(() => {
          this.vaildScanQRRecharge(res.payNo, timer);
        }, 3000);
      }
    },
    // 验证是否成功
    async vaildScanQRRecharge(payNo, timer) {
      let params = {
        payNo,
      };
      let result = await this.$api.vaildScanQRRecharge(params);
      let res = result.data;
      if (res.numberOrder) {
        clearInterval(timer);
        this.isSuccessDialog = true;
        this.amount = "";
        this.isScanDialog = false;
        this.printItem = res;
        // setTimeout(() => {
        //   document.getElementById("printId").click();
        // }, 300);
        // setTimeout(() => {
        //   document.getElementById("printId").click();
        // }, 600);
        if (this.isPhoneRecharge) {
          this.phoneRecharge();
        } else {
          this.getByCardNumber();
        }
      }
    },
    // 获取公司名称
    async getCompanyInfo() {
      let res = await this.$api.getCompany();
      this.companyName = res.name;
    },
  },
  mounted() {
    this.getCompanyInfo();
    let cardNumber = this.$route.query.cardNumber;
    if (cardNumber) {
      this.oldCardNumber = cardNumber;
      this.cardNumber = "00000000";
      setTimeout(() => {
        this.getByCardNumber();
      }, 300);
    }
  },
};
</script>
<style lang="stylus">
.popMessage {
  width: 700px;
  margin-top: -400px;
  padding: 0px;
  padding-bottom: 30px;

  .el-message-box__header {
    width: 700px;
  }

  .el-message-box__title {
    font-size: 24px;
  }

  .el-button {
    width: 100px;
    height: 40px;
    border-radius: 4px;
    font-size: 16px;
    font-weight: 400;
    padding: 0;

    &:first-child {
      margin-right: 60px;
    }
  }
}

.success-dialog {
  width: 620px;
  height: 440px;
}

.success-pop {
  width: 620px;
  height: 440px;
  align-items: center;
  justify-content: center;

  img {
    width: 113px;
    height: 136px;
    margin-bottom: 55px;
  }

  .title {
    font-size: 32px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 30px;
    margin-bottom: 33px;
  }

  .subtitle {
    font-size: 32px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 30px;

    b {
      color: #3897FF;
      margin-left: 20px;
      margin-top: 5px;
    }
  }
}

.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.recharge {
  .recharge-body {
    padding: 0.2rem 1.17rem;
  }

  .recharge-info-body {
    padding: 0.05rem 0.82rem 0.38rem 0.82rem;
  }

  .layout-card-header {
    justify-content: start;

    .phone-recharge {
      display: flex;
      align-items: center;

      input {
        width: 2.54rem;
        height: 0.4rem;
        background: rgba(239, 241, 245, 1);
        border: 1px solid rgba(219, 220, 222, 1);
        border-radius: 4px;
        font-size: 0.16rem;
        font-family: Microsoft YaHei UI;
        font-weight: 400;
        color: #000000;
        padding-left: 0.13rem;
        margin-left: 1.13rem;
        margin-right: 0.14rem;

        &::-webkit-input-placeholder {
          color: rgba(121, 121, 121, 1);
        }

        &:focus {
          background: rgba(255, 255, 255, 1);
        }
      }

      .rechargePhoneBtn {
        width: 0.8rem;
        height: 0.4rem;
        background: rgba(55, 151, 255, 1);
        border: 1px solid rgba(55, 151, 255, 1);
        border-radius: 4px;
        border: 0;
        font-size: 16px;
        font-family: Microsoft YaHei UI;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
      }
    }
  }
}

.recharge-form {
  .item {
    width: 100%;
    margin-bottom: 0.23rem;
    position: relative;

    .name {
      font-size: 0.15rem;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      position: relative;
      margin-bottom: 0.14rem;

      img {
        width: 0.1rem;
        height: 0.1rem;
        margin-left: 0.08rem;
      }
    }

    .cardnumber-box {
      .number-left {
        width: 1.4rem;
        height: 0.48rem;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(211, 211, 211, 1);
        border-radius: 4px;
        font-size: 0.28rem;
        font-weight: bold;
        color: rgba(56, 151, 255, 1);
        text-align: center;
        margin-right: 0.16rem;
        line-height: 0.48rem;

        &::-webkit-input-placeholder {
          font-size: 0.18rem;
          font-weight: 400;
          transform: translate(0, -2px);
        }
      }

      .number-right {
        width: 2.84rem;
        height: 0.48rem;
        background: rgba(248, 248, 248, 1);
        border: 1px solid rgba(211, 211, 211, 1);
        border-radius: 4px;
        font-size: 0.28rem;
        font-weight: bold;
        color: rgba(56, 151, 255, 1);
        text-align: center;
        padding: 0 0.17rem;
        line-height: 0.48rem;

        &::-webkit-input-placeholder {
          font-size: 0.18rem;
          font-weight: 400;
          transform: translate(0, -2px);
        }
      }
    }

    .form-input {
      width: 100%;
      height: 0.4rem;
      border-radius: 4px;
      border: 0;
      padding-left: 0.18rem;
      font-size: 0.18rem;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      background: rgba(248, 248, 248, 1);
      border: 1px solid rgba(224, 224, 224, 1);
    }

    .use-input {
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(224, 224, 224, 1);
    }
  }
}

.recharge-info-form {
  // width: 934px;
  padding-left: 0.8rem;
  margin: 0.45rem auto 0;

  .price-item {
    display: flex;
    align-items: center;

    .title {
      font-size: 0.24rem;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      line-height: 1.8rem;
      flex-shrink: 0;
      margin-right: 1rem;
      position: relative;

      &::before {
        content: '';
        width: 10px;
        height: 10px;
        background: url('../../assets/images/icon/icon_asterisk.png');
        position: absolute;
        left: -0.3rem;
      }

      img {
        margin-left: 0.12rem;
        width: 0.1rem;
        height: 0.1rem;
      }
    }

    .box {
      width: 10.7rem;
      height: 1.8rem;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(211, 211, 211, 1);
      border-radius: 4px;
      padding: 0.18rem 0.42rem;
      position: relative;
      display: flex;
      align-items: center;

      h1 {
        font-size: 1rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: rgba(243, 132, 13, 1);
        flex-shrink: 0;
      }

      .price-input {
        width: 100%;
        height: 100%;
        border: 0;
        // font-family: 'huawen';
        font-size: 1.5rem;
        line-height: 1.5rem;
        text-align: center;
        color: #F3840D;
        flex: 1;
      }

      span {
        font-size: 0.24rem;
        font-weight: 500;
        color: rgba(153, 153, 153, 1);
        position: relative;
        bottom: -0.38rem;
      }
    }
  }

  .tip {
    font-size: 0.28rem;
    margin: 0 auto;
    color: #333;
    margin-top: 0.2rem;
    display: flex;
    align-items: center;

    .title {
      font-size: 24px;
      font-weight: 400;
      flex-shrink: 0;
      margin-right: 0.7rem;
    }

    .right {
      width: 10.7rem;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }

    .left {
      height: 0.4rem;
      display: flex;
      align-items: center;
      justify-content: center;

      .el-checkbox {
        height: 0.4rem;
        display: flex;
        align-items: center;
        justify-content: center;

        .el-checkbox__input {
          margin-top: 0.04rem;

          .el-checkbox__inner {
            width: 0.18rem;
            height: 0.18rem;
            background: rgba(243, 243, 243, 1);
            border: 1px solid rgba(168, 168, 168, 1);
            border-radius: 50%;
          }

          &.is-checked {
            .el-checkbox__inner {
              border-color: #409EFF;
              background: none;

              &:after {
                width: 0.1rem;
                height: 0.1rem;
                background: rgba(56, 151, 255, 1);
                border-radius: 50%;
                transform: translate(-50%, -50%) scale(1);
                top: 50%;
                left: 50%;
                border: 0;
              }
            }
          }
        }

        .el-checkbox__label {
          font-size: 0.16rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
        }
      }
    }
  }

  .remark-item {
    display: flex;
    align-items: center;

    // margin-top: 14px;
    .title {
      font-size: 24px;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      line-height: 150px;
      flex-shrink: 0;
      margin-right: 70px;

      img {
        margin-left: 12px;
      }
    }

    .remark-text {
      width: 10.7rem;
      height: 0.8rem;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(211, 211, 211, 1);
      border-radius: 4px;
      padding: 0.15rem;
      font-size: 0.16rem;
    }
  }
}

.recharge-vip-form {
  width: 673px;
  margin: 45px auto 0;

  .item {
    margin-bottom: 32px;

    .name {
      width: 146px;
      font-size: 24px;
      color: #666666;
      line-height: 30px;
      margin-right: 48px;
      text-align: justify;
      position: relative;
      top: 13px;

      i {
        display: inline-block;
        width: 100%;
        padding-left: 100%;
      }
    }

    .text {
      width: 424px;
      height: 64px;
      background: #FFFFFF;
      border: 1px solid #D3D3D3;
      border-radius: 4px;
      margin-right: 32px;
      font-size: 36px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #000000;
      padding: 0 22px;

      &::-webkit-input-placeholder {
        font-size: 17px;
        position: relative;
        top: -8px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
      }
    }

    .unit {
      width: 23px;
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #999999;
    }
  }
}

.item-foot {
  width: 100%;
  justify-content: center;
  margin-bottom: 0;
  margin-right: 0;
  margin-top: 15px;
}

.scan-dialog {
  height: auto;
}

.scan-dialog-body {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 30px;

  h2 {
    font-size: 24px;
  }

  .box {
    width: 456px;
    height: 52px;
    background: #ccc;
    margin-top: 15px;
    padding: 0 25px;

    p {
      font-size: 16px;
      color: #333333;

      span {
        font-weight: bold;
      }
    }
  }

  .total {
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #333333;
    margin-top: 20px;

    span {
      font-size: 24px;
      font-weight: bold;
      color: #f3840d;
    }
  }

  .scan-box {
    width: 220px;
    height: 220px;
    border: 1px solid #666;
    margin-top: 15px;
    padding: 10px;

    .qrcode {
      width: 100%;
      height: 100%;

      img {
        width: 100%;
      }
    }
  }

  .scan-foot {
    display: flex;
    align-items: center;
    margin-top: 10px;

    img {
      max-width: 150px;
    }
  }
}
</style>
